import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QuoteRequest, QuoteResponse, QuoteApplicationsPage } from '../models/quote.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/QuoteRequests`;

  submitApplication(data: QuoteRequest): Observable<QuoteResponse> {
    console.log('Sending Quote application:', data);
    return this.http.post<QuoteResponse>(this.apiUrl, data);
  }

  getApplications(pageNumber: number = 1, pageSize: number = 10): Observable<QuoteApplicationsPage> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<QuoteApplicationsPage>(this.apiUrl, { params });
  }

  getApplicationById(id: number): Observable<QuoteResponse> {
    return this.http.get<QuoteResponse>(`${this.apiUrl}/${id}`);
  }
}